// extracted by mini-css-extract-plugin
export var sliderRange = "_qx-2";
export var sliderRoot = "_qx-0";
export var sliderThumb = "_qx-3";
export var sliderTrack = "_qx-1";